/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import LeftMenu from "components/common/LeftMenu";
import UserMenu from "components/common/UserMenu";
import BudgetBreadCrumb from "components/Budget/BreadCrumb/BudgetBreadCrumb";
import BudgetFilter from "components/Budget/Filter/BudgetFilter";
import ToggleColumn from "components/Budget/ToggleColumn/ToggleColumn";
import BudgetHeader from "components/Budget/Header/BudgetHeader";
import CustomNotification from "components/common/CustomNotification";
import BudgetList from "components/Budget/BudgetList/BudgetList";
import BudgetSendMailPopup from "components/common/Popup/BudgetSendMailPopup";
import SaveBudgetPopup from "components/Budget/Popup/SaveBudgetPopup";
import SaveSalesOrderPopup from "components/Budget/Popup/SaveSalesOrderPopup";
const Budget = () => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  /* useState hook to download excel file */
  const [downloadExcel, setDownloadExcel] = useState(false);
  const blockRefSelected = useRef(null); // this will be used to acccess dom element directly
  /* hook to get number of records */
  const [records, setRecords] = useState(0);
  /* function for checking record count */
  const checkedRecordCount = (selectCount) => {
    // console.log("Count in sales order----->", selectCount);
    const blockElementSelect = ReactDOM.findDOMNode(blockRefSelected.current);
    if (blockElementSelect) {
      blockElementSelect.innerHTML = selectCount;
    }
  };
  /* hook to search */
  const [search, setSearch] = useState("");
  useEffect(() => {
    document.title = "Budget";
  }, []);
  return (
    <>
      <UserMenu />
      <LeftMenu />
      {userInfo?.role?.name == "admin" || userInfo?.role?.name == "manager" ? (
        <section className="sales-order-wrapper pt-2">
          <div className="container-fluid px-4">
            <BudgetBreadCrumb />
            <BudgetHeader
              setDownloadExcel={setDownloadExcel}
              blockRefSelected={blockRefSelected}
              setSearch={setSearch}
              records={records}
            />
            <ToggleColumn />
            <BudgetFilter />
            <BudgetList
              search={search}
              downloadExcel={downloadExcel}
              checkedRecordCount={checkedRecordCount}
              setRecords={setRecords}
            />
            {/* ------ all popup render here ------ */}
            <SaveBudgetPopup />
            <SaveSalesOrderPopup />

            <BudgetSendMailPopup moduleName={"budget"} />
          </div>
          {/*----------- custom notification component start -----------*/}
          <CustomNotification />
          {/*----------- custom notification component end -----------*/}
        </section>
      ) : null}
    </>
  );
};
export default Budget;
